/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from "react";

import { Tags, Tag, TagTitle, InputTags, Container, DocumentType, Line } from "./styles"
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import Icon from "components/Icon";

const TagsList2 = ({ hideTrash, disableType, tags, disabled, removeTag }) => {
    /*
        function base64ToArrayBuffer(base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        }
    
        function saveByteArray(reportName, byte, t) {
            var blob = new Blob([byte], { type: t });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var fileName = reportName;
            link.download = fileName;
            link.click();
        };
    
          useEffect(()=>{
             console.log('files',props.tags);
         },[props.tags]) */


    return (
        <Container>
            <Line />
            {tags ? tags.map((tag, index) => (
                <Tags key={index}>
                    { !disableType ?
                        <Col md={5} sm={4} xs={3}>
                            <DocumentType>
                                {tag.dsTypeDocument}
                            </DocumentType>
                        </Col> : ""}
                    <Col md={!disableType ? 6 : 11} sm={!disableType ? 7 : 11} xs={!disableType ? 8 : 11}>
                        <Tag>
                            <TagTitle onClick={() => window.open(tag.urlLink, "_blank")}>{tag.nameDocument}</TagTitle>
                        </Tag>
                    </Col >

                    <Col md={1} sm={1} xs={1} style={{ padding: "0px 0px 0px 0px", direction: "rtl" }}>
                        {!hideTrash ?
                            <Row>
                                {disabled ? '' : <Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => removeTag(index)}></Icon>}
                            </Row>
                            : ''
                        }
                    </Col>
                    <Line />
                </Tags >
            )) : <></>
            }
        </Container >
    );
};
export default TagsList2;